import { render, staticRenderFns } from "./FeedSchedule.vue?vue&type=template&id=4484ed81"
import script from "./FeedSchedule.vue?vue&type=script&lang=ts"
export * from "./FeedSchedule.vue?vue&type=script&lang=ts"
import style0 from "./FeedSchedule.vue?vue&type=style&index=0&id=4484ed81&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports